import {
  Box,
  InputAdornment,
  Stack,
  Typography
} from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import { visuallyHidden } from "@mui/utils";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CommonModel from "../../../components/dialog/Common";
import useDebounce from "../../../hooks/use.debounce";
import { resetSubscription } from "../../subscriptions/subscriptionSlice";
import { deleteNotification, getNotificationList } from "../action";
import { updateNotification } from "../notificationSlice";
import CustomPagination from "../../../utils/CustomPagination";
import { CustomSearchInput, TABLE_BODY_ROW_MUI_STYLES, TABLE_HEADER_ROW_MUI_STYLES } from "../../../utils/constant";
import searchIcon from "../../../assets/images/icons/searchIcon.svg"

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort, isSticky } = props;
  const createSortHandler =
    (property) => (event) => {
      if (["type", "status", "nextScheduleDate", "frequency"].includes(property)) {
        onRequestSort(event, property);
      } else {
        return;
      }
    };

  const headCells = [
    {
      id: "name",
      numeric: false,
      disablePadding: true,
      label: "Group Name",
      type: "",
    },
    {
      id: "type",
      numeric: false,
      disablePadding: true,
      label: "Type",
      type: "",
    },
    {
      id: "status",
      numeric: false,
      disablePadding: true,
      label: "Status",
      type: "",
    },
    {
      id: "nextScheduleDate",
      numeric: false,
      disablePadding: true,
      label: "Date & Time",
      type: "",
    },
    {
      id: "frequency",
      numeric: false,
      disablePadding: true,
      label: "Is Scheduled",
      type: "",
    },
    {
      id: "messageTitle",
      numeric: false,
      disablePadding: true,
      label: "Message Title",
      type: "",
    },
    {
      id: "messageBody",
      numeric: false,
      disablePadding: true,
      label: "Message Body",
      type: "",
    },
    {
      id: "action",
      numeric: false,
      disablePadding: true,
      label: "Actions",
      type: "",
    },
  ];

  return (
    <TableHead className={`hideActionSort ${isSticky} `}>
      <TableRow sx={TABLE_HEADER_ROW_MUI_STYLES}>

        {headCells.map((headCell) => {
          return (
            <TableCell
              key={headCell?.id}
              align={headCell.numeric ? "right" : "left"}
              padding={headCell.disablePadding ? "none" : "normal"}
              sortDirection={orderBy === headCell.id ? order : false}
              sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
            >
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                onClick={createSortHandler(headCell.id)}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === "desc"
                      ? "sorted descending"
                      : "sorted ascending"}
                  </Box>
                ) : null}
              </TableSortLabel>
            </TableCell>
          );
        })}
      </TableRow>
    </TableHead>
  );
}


export default function NotificationHistory() {
  const navigate = useNavigate();
  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("id");
  const [open, setOpen] = useState(false);
  const [ids, setIds] = useState([]);
  const [sticky, setSticky] = useState("");
  const dispatch = useDispatch();
  const {
    nLimit,
    nPage,
    sortKey,
    totalPages,
    nFilters,
    notificationListing,totalCount
  } = useSelector((state) => state.notificationSlice);
  const debouncedSearch = useDebounce(nFilters.search, 500);
  const handleRequestSort = (
    event,
    property
  ) => {
    const isAsc = orderBy === property && order === "asc";

    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
    dispatch(
      updateNotification({
        sortType: isAsc ? "asc" : "desc",
        sortKey: property,
      }),
    );
    dispatch(getNotificationList())
  };

  useEffect(() => {
    if (debouncedSearch || nFilters.search == "")
      dispatch(getNotificationList())
  }, [debouncedSearch]);

  useEffect(() => {
    dispatch(
      updateNotification({
        sortKey: "nextScheduleDate"
      }),
    );
    dispatch(getNotificationList())
    return () => dispatch(resetSubscription())
  }, []);

  const handleSearch = (event) => {
    dispatch(updateNotification({ nFilters: { ...nFilters, search: event.target.value }, nPage: 0 }));
  };

  const handleSearchClear = () => {
    dispatch(updateNotification({ nFilters: { ...nFilters, search: "" } }));
    dispatch(getNotificationList());
  };

  const handleChange = (value) => {
    dispatch(updateNotification({ nPage: value - 1 }));
    dispatch(getNotificationList());
  };
  const handleChangePerPage = (event, value) => {
    dispatch(updateNotification({ nLimit: event.target.value, nPage: 0 }));
    dispatch(getNotificationList());
  };
  return (
    <>
      <Stack direction={"column"} gap={2}>
        <Stack
          direction={"row"}
          alignItems={"center"}
          justifyContent={"space-between"}
          sx={{
            minHeight: '42px',paddingX:'16px',
          }}
        >
          <Typography className="page-title" variant="h1">Notification History</Typography>
          <CustomSearchInput
              className="inputSearch sContrl p-0"
              value={nFilters.search}
              placeholder={"Search here..."}
              handleSearch={handleSearch}
              clearSearch={handleSearchClear}
              startAdornment={
              <InputAdornment style={{ borderRadius: '50px !important' }} className="overIcon" position="start"
                sx={{
                  maxHeight: 'none',
                  height: '38px',
                  minWidth: '38px',
                  marginRight: '0px', background: 'none !important', borderRadius: '50px !important'
                }}
              >
                <img src={searchIcon} height={20} width={20} alt="" srcset="" />
              </InputAdornment>
            }
          />
        </Stack>
        <Box
          sx={{
            backgroundColor: '#fff',
            transition: 'all .5s ease-in-out',
            position: 'relative',
          }}>
            <TableContainer>
              <Table stickyHeader aria-label="sticky table">
                <EnhancedTableHead
                  isSticky={sticky}
                  order={order}
                  orderBy={sortKey}
                  notificationListing={notificationListing}
                  setIds={setIds}
                  ids={ids}
                  onRequestSort={handleRequestSort}
                  numSelected={0}
                  onSelectAllClick={function (

                  ) {
                    throw new Error("Function not implemented.");
                  }}
                />
                <TableBody>
                  {notificationListing && notificationListing?.length ? (
                    notificationListing?.map((row) => {
                      return (
                        <TableRow
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={row.id}
                          className={"tableRow"}
                          sx={TABLE_BODY_ROW_MUI_STYLES}>
                          <TableCell component="td" scope="row">
                            {row?.groupNames || "N/A"}
                          </TableCell>
                          <TableCell component="td" scope="row">
                            {row.type}
                          </TableCell>
                          <TableCell component="td" scope="row">
                            <button className={row.status?.toLowerCase() + " capitalize-first-letter"}>{row.status}</button>
                          </TableCell>

                          <TableCell component="td" scope="row">
                            {row?.nextScheduleDate || "N/A"}
                          </TableCell>
                          <TableCell component="td" scope="row">
                            {row.frequency == "oneTime" ? "No" : "Yes"}
                          </TableCell>
                          <TableCell align="left">
                            {row?.title || "N/A"}
                          </TableCell>
                          <TableCell align="left">
                            {row?.message || "N/A"}
                          </TableCell>
                          <TableCell sx={{ cursor: "pointer" }}>
                            <Stack direction={"row"} gap={2}>
                              {row.status == "Pending" ? <><span className="editIcon" onClick={() => navigate(`/notification/${row.id}/edit`, { state: row })}>Edit</span>
                                <span className="viewIcon" style={{ color: "red" }} onClick={() => {
                                  setOpen(row.id)
                                }}>
                                  Delete
                                </span></> : <>-</>}
                            </Stack>
                          </TableCell>
                        </TableRow>
                      );
                    })
                  ) : (
                    <TableRow colSpan={10}>
                      <TableCell colSpan={10} style={{ textAlign: 'center' }}>

                        <Typography
                          color="inherit"
                          variant="subtitle1"
                          alignItems={"center"}
                          component="h3"
                        >
                          No Data found!
                        </Typography>

                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>

            </TableContainer>
                      <Stack
            sx={{
              background: 'transparent',
              height: '60px',
              border: '1px solid #E9EAEB'
            }}
            direction="row"
            alignItems={"center"}
            justifyContent={"flex-end"}>
            <CustomPagination
              count={Math.ceil(totalPages / nLimit) || 0}
              onChange={handleChange}
              currentPage={nPage}
              handleChangePerPage={handleChangePerPage}
              limit={nLimit}
              listingCount={notificationListing?.length}
              totalCount={totalCount}
              defaultPage={1} siblingCount={1} boundaryCount={1} />
          </Stack>
          <CommonModel
            open={open}
            handleDialogClose={() => setOpen(false)}
            dialogTitle={"Delete Notification"}
            dialogPara={`Are you sure, you want to delete this notification?`}
            nvYes={"Yes"}
            className={"btnDanger"}
            nvCancel={"Cancel"}
            yesHandle={() => {
              dispatch(deleteNotification(open, setOpen));
            }}
          />
        </Box>
      </Stack>

    </>
  );
}
